import { useMemo, useRef } from 'react';
import { collectReadyAttachmentRefs, hasNonReadyComposerAttachments } from '../../application/composer/attachment-send-refs.js';
export { buildComposerAttachmentErrorPatch, buildComposerAttachmentPatchFromSource } from '../../projection/composer/attachment-patches.js';

/** Display projection only. Controller owns upload, polling, cancellation and metadata. */
export function useComposerAttachmentSync({ composerFileList = [] } = {}) {
  const composerFileListRef = useRef(composerFileList);
  composerFileListRef.current = composerFileList;
  return useMemo(() => ({
    composerFileListRef,
    readyAttachmentRefs: collectReadyAttachmentRefs(composerFileList),
    hasNonReadyAttachments: hasNonReadyComposerAttachments(composerFileList),
    syncErrors: composerFileList.filter((item) => item.error_message).map(({ uid, source_id, error_message }) => ({ uid, source_id, error_message })),
  }), [composerFileList]);
}
export default useComposerAttachmentSync;
